export default {
  pick_favorites: "Choose your Favorites",
  recommended: "Recommended",
  category: "Category",
  author: "Author",
  authors: "Authors"
}
  